module.exports = __webpack_public_path__ + "static/img/FESCO@2x.d45b81c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/FESCO@2x.png
// module id = drey
// module chunks = 0